import React, { useEffect, useState } from 'react';

import { Layout, Menu, Badge } from 'antd';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import AvatarComponent from '../common/avatar';
import Notification from './notification/Notification';
import SideNav from './sidenav/Sidenav';
import { isLogin } from '../../helpers/loginHelper';
import { BellOutlined } from '@ant-design/icons';
import { logoutUser } from '@/actions/auth';
import { getNotifications } from '@/actions/notifications';
import PermissionHandler from '@/helpers/PermissionHandler';

const { Header, Content, Footer } = Layout;
const { SubMenu } = Menu;

interface IProps {
  children: any;
}
const LayoutComponent = (props: IProps) => {
  const user = useSelector((state: any) => state.auth?.creds?.user_data);
  const user_avatar = useSelector(
    (state: any) => state.auth?.creds?.user_data?.avatar
  );
  const router = useRouter();
  const dispatch = useDispatch();

  const permission = useSelector(
    (state: any) => state.auth?.creds?.user_data?.permission?.notification
  );
  const user_type = useSelector(
    (state: any) => state.auth?.creds?.user_data?.user_type
  );
  const notification = useSelector(
    (state: any) => state?.notificationReducer?.notification
  );
  const unreadCount = notification?.unreadCount;
  const [showbadgeCount, setshowBadgeCount] = useState(false);
  const [bCount, setBCount] = useState(null);
  const query = {
    page: 1,
    per_page: 10,
  };
  let token: any;

  useEffect(() => {
    token = window.localStorage.getItem('token');
    if (token && notification?.data?.length === 0) {
      dispatch(getNotifications(query));
    }
  }, []);

  useEffect(() => {
    if (!isLogin() || user_type == 'client') {
      window.location.pathname = '/';
    }
  }, [isLogin()]);

  const handleLogout = async (e) => {
    e.preventDefault();
    dispatch(logoutUser());
  };

  const handleBadgeCount = () => {
    setshowBadgeCount(true);
  };

  const handleBCount = (count) => {
    setBCount(count);
  };
  let currentYear = new Date().getFullYear();

  return (
    <div>
      {!isLogin() || user_type === 'client' ? null : (
        <Layout className="dashboard-layout">
          <SideNav />
          <Layout>
            <Header
              className="site-layout-sub-header-background"
              style={{ padding: 0 }}
            >
              <div className="ml-auto pr-5 float-right">
                <Menu mode="horizontal" triggerSubMenuAction={'click'}>
                  <PermissionHandler permission={permission?.view_notification}>
                    <SubMenu
                      key="notification"
                      title={
                        <Badge
                          count={
                            showbadgeCount
                              ? bCount < 0
                                ? ''
                                : bCount
                              : unreadCount < 0
                              ? ''
                              : unreadCount
                          }
                        >
                          <span className="submenu-title-wrapper">
                            <BellOutlined rev="" size={30} />
                          </span>
                        </Badge>
                      }
                    >
                      <Notification
                        handleBadgeCount={handleBadgeCount}
                        handleBCount={handleBCount}
                      />
                    </SubMenu>
                  </PermissionHandler>
                  <SubMenu
                    key="user"
                    title={
                      <AvatarComponent
                        avatar={user_avatar}
                        firstName={user?.first_name}
                        lastName={user?.last_name}
                        size={45}
                      />
                    }
                  >
                    <a
                      onClick={(e) => router.push('/dashboard/profile')}
                      className="nav-link dropdown-profile-menu"
                    >
                      <i className="far fa-user mr-1"></i> My Profile
                    </a>
                    {user?.is_superuser && (
                      <a
                        onClick={(e) => router.push('/dashboard/settings')}
                        className="nav-link dropdown-profile-menu"
                      >
                        <i className="fas fa-cog mr-1"></i>Settings
                      </a>
                    )}
                    <a
                      onClick={(e) => handleLogout(e)}
                      className="nav-link dropdown-profile-menu"
                    >
                      <i className="fas fa-sign-out-alt mr-1"></i> Logout
                    </a>
                  </SubMenu>
                </Menu>
              </div>
            </Header>

            <Content>
              <div className="site-layout-background">{props.children}</div>
            </Content>

            <Footer style={{ textAlign: 'center' }}>
              Copyright © {currentYear} Learnsic | All rights reserved
            </Footer>
          </Layout>
        </Layout>
      )}
    </div>
  );
};

export default LayoutComponent;
